import { FC, useContext } from 'react';

import { H2, LockIcon, RightUpIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { AuthContext } from 'auth';
import { LocalizationContext } from 'localization';

import s from './FeatureHOC.module.scss';

export const FeatureHOC: FC<{ isCountry?: boolean }> = ({ isCountry }) => {
  const { t } = useContext(LocalizationContext);
  const {
    data: { isOwner },
  } = useContext(AuthContext);

  return (
    <div
      onClick={() => {
        isOwner ? window.open('https://lk.smartshell.gg') : '';
      }}
      className={cn(s.container, !isOwner && s.container_admin)}
    >
      {isCountry ? (
        <div className={s.message}>
          <H2 className={s.title}>{t('settings.country_code.error')}</H2>
        </div>
      ) : (
        <>
          {isOwner && <RightUpIcon size="s" className={s.linkView} />}
          <div className={s.message}>
            <H2 className={s.title}>{t('feature.unavailable.secondary')}</H2>
            <span className={s.subtitle}>
              {isOwner
                ? t('feature.unavailable.subtitle.owner')
                : t('feature.unavailable.subtitle.admin')}
            </span>
          </div>
          {isOwner && (
            <div className={s.button_block}>
              <div className={s.button}>
                <LockIcon size="s" color="violet" />
                {t('feature.unlock')}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
